import { NgModule } from '@angular/core';
import { HeightChangeDirective } from './height-change.directive';


@NgModule({
    imports: [],
    exports: [HeightChangeDirective],
    declarations: [HeightChangeDirective],
    providers: [],
})
export class HeightChangeDirectiveModule { }
